var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsLoseIntrest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.2,20.22h-9.26L16.49,3.95h6.97l-4.75,11.81h11.89l-16.48,17.11,5.09-12.65ZM21.86,13.62L26.61,1.82h-11.56L6.78,22.35h9.26l-6.37,15.83h2.28l23.65-24.56h-13.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsLoseIntrest);
export default __webpack_public_path__ + "static/media/leads-lose-intrest.4f99d129d33a56f2e60c46d4bb02db26.svg";
export { ForwardRef as ReactComponent };